import { EntityId } from "@reduxjs/toolkit";
import { DossierCapabilityName } from "./DossierCapabilityName";
import { DossierPriority } from "./DossierPriority";

export interface CreateDossierRequest {
    // nominal typing: https://github.com/Microsoft/TypeScript/blob/7b48a182c05ea4dea81bab73ecbbe9e013a79e99/src/compiler/types.ts#L693-L698
    _createDossierRequestBrand: never;

    name?: string;
    siteId?: string;
    priority?: DossierPriority;
    externalReference?: string;
    startTime?: string;
    endTime?: string;
    selectedDeviceIds: EntityId[];
    dossierCapabilityNames: DossierCapabilityName[];
}

export function isCreateDossierRequest(x: unknown): x is CreateDossierRequest {
    return (x as CreateDossierRequest)._createDossierRequestBrand !== undefined;
}
